import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from 'vue';
import { usersService } from '@/services/users.service';
import {
  maxLength,
  passwordsMatch,
  required,
  withLocalizedValidators,
} from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetModal',
  props: {
    id: null,
    email: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  id: number;
  email: string;
};




const isSubmitting = ref<boolean>(false);
const otherPassword = ref('');

const state = reactive({
  password: '',
});
const validations = {
  password: withLocalizedValidators('user.password', {
    required,
    maxLength: maxLength(256),
    password_repeat: passwordsMatch(otherPassword),
  }),
};
const v$ = useVuelidate(validations, state);
const { t } = useI18n();

async function onSubmit() {
  isSubmitting.value = true;
  usersService
    .changePassword(props.id, props.email, state.password)
    .then(() => closeModal())
    .finally(() => (isSubmitting.value = false));
}

function closeModal() {
  emit('close');
}

const validationMessage = computed(
  () => v$.value.password.$errors[0]?.$message,
);

return { __sfc: true,props, emit, isSubmitting, otherPassword, state, validations, v$, t, onSubmit, closeModal, validationMessage }
}

})